import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32850412"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shadow-edit" }
const _hoisted_2 = { class: "shadow-edit__settings" }
const _hoisted_3 = { class: "shadow-edit__settings__item mb-4" }
const _hoisted_4 = { class: "shadow-edit__settings__title" }
const _hoisted_5 = { class: "shadow-edit__settings__content shadow-edit__settings__content--padding" }
const _hoisted_6 = { class: "shadow-edit__settings__item mb-4" }
const _hoisted_7 = { class: "shadow-edit__settings__title" }
const _hoisted_8 = { class: "shadow-edit__settings__content shadow-edit__settings__content--padding" }
const _hoisted_9 = { class: "shadow-edit__settings__item mb-4" }
const _hoisted_10 = { class: "shadow-edit__settings__title mb-0" }
const _hoisted_11 = { class: "shadow-edit__settings__content" }
const _hoisted_12 = { class: "shadow-edit__settings__padding" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shadow-edit__settings__padding__item__icon" }, null, -1))
const _hoisted_14 = { class: "shadow-edit__settings__padding__item__value" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shadow-edit__settings__padding__item__icon" }, null, -1))
const _hoisted_16 = { class: "shadow-edit__settings__padding__item__text" }
const _hoisted_17 = { class: "shadow-edit__settings__padding__item__value" }
const _hoisted_18 = { class: "shadow-edit__settings__item" }
const _hoisted_19 = { class: "shadow-edit__settings__title" }
const _hoisted_20 = { class: "shadow-edit__settings__content" }
const _hoisted_21 = { class: "shadow-edit__settings__sizes" }
const _hoisted_22 = { class: "shadow-edit__settings__sizes__item__icon" }
const _hoisted_23 = { class: "shadow-edit__settings__sizes__item__text" }
const _hoisted_24 = { class: "shadow-edit__settings__sizes__item__value" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shadow-edit__divider" }, "×", -1))
const _hoisted_26 = { class: "shadow-edit__settings__sizes__item__icon" }
const _hoisted_27 = { class: "shadow-edit__settings__sizes__item__text" }
const _hoisted_28 = { class: "shadow-edit__settings__sizes__item__value" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shadow-edit__divider" }, "×", -1))
const _hoisted_30 = { class: "shadow-edit__workarea" }
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "shadow-edit__workarea__data" }
const _hoisted_33 = { class: "shadow-edit__workarea__actions" }

import { computed, onMounted, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useEventBus } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import i18n from '@/plugins/i18n';

import { useCommonStore } from '@/store/common';
import { useServicesStore } from '@/store/services';

// import { getBase64Size } from '@/helpers/getBase64Size';
import { removeBase64Prefix } from '@/helpers/removeBase64Prefix';

import AiButton from '@/components/UI/AiButton/AiButton.vue';
import AiCard from '@/components/UI/AiCard/AiCard.vue';
import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';
import AiDropLoader from '@/components/UI/AiDropLoader/AiDropLoader.vue';
import AiLocked from '@/components/UI/AiLocked/AiLocked.vue';

import AddImage from '@/components/common/AddImage/AddImage.vue';
import ColorsList from '@/components/common/ColorsList/ColorsList.vue';
import ImageFinetune from '@/components/common/ImageFinetune/ImageFinetune.vue';
import ResultImage from '@/components/common/ResultImage/ResultImage.vue';
import ShadowType from '@/components/pages/Shadow/ShadowType/ShadowType.vue';
import TimeCounter from '@/components/common/TimeCounter/TimeCounter.vue';

import { sizesRu } from '@/data/outpaintSizes/sizesRu';
import { sizesEn } from '@/data/outpaintSizes/sizesEn';


export default /*#__PURE__*/_defineComponent({
  __name: 'Shadow',
  setup(__props) {

const paddingList = [8, 14];

const { t } = useI18n();

const busError = useEventBus<string>('toast-error');

const { generateImage } = useServicesStore();

const { isMobile } = storeToRefs(useCommonStore());
const { imageForActions, imageResult, imagePrev } = storeToRefs(useServicesStore());

const key = ref<number>(0);
const generationLoading = ref<boolean>(false);
const sizeIndex = ref<number>(0);
const customWidth = ref<number>(0);
const customHeight = ref<number>(0);
const imageWidth = ref<number>(0);
const imageHeight = ref<number>(0);
const canvasWidth = ref<number>(0);
const canvasHeight = ref<number>(0);
const paddingIndex = ref<number>(0);
const padding = ref<number>(0);
const imgContainerRef = ref<any>();
const shadowType = ref<number>(0);
const shadowColor = ref<string>('');
const isEdit = ref<boolean>(false);

const ratio = computed(() => {
  let result = 0;
  if (imgContainerRef.value) {
    if (
      imgContainerRef.value.clientWidth / imgContainerRef.value.clientheight > canvasWidth.value / canvasHeight.value
    ) {
      result = imgContainerRef.value.clientWidth / canvasWidth.value;
    } else {
      result = imgContainerRef.value.clientHeight / canvasHeight.value;
    }
  }
  return result;
});

const lang = computed(() => i18n.global.locale.value);
// const imageSize = computed(() => getBase64Size(imageForActions.value));
const sizesList = computed(() => (lang.value === 'ru' ? sizesRu : sizesEn));
const computedPadding = computed(() => {
  let result = padding.value;
  if (paddingIndex.value !== -1) {
    if (canvasWidth.value / canvasHeight.value > imageWidth.value / imageHeight.value) {
      result = (canvasHeight.value / 100) * paddingList[paddingIndex.value];
    } else {
      result = (canvasWidth.value / 100) * paddingList[paddingIndex.value];
    }
  }
  return result;
});

const shadowFileHandler = (): void => {
  generationLoading.value = true;

  generateImage({
    action: 'shadow',
    image: removeBase64Prefix(imageForActions.value),
    params: {
      mode: shadowType.value,
      padding: computedPadding.value,
      color: shadowColor.value,
      size: {
        height: canvasHeight.value,
        width: canvasWidth.value,
      },
    },
  })
    .then((res) => {
      imagePrev.value = `data:image/png;base64,${res.payload.imageWithPadding}`;
    })
    .catch((e) => {
      busError.emit(e?.message || t('common.err-gen'));
    })
    .finally(() => {
      generationLoading.value = false;
    });
};

const setSize = (index: number): void => {
  sizeIndex.value = index;
  if (index === -1) {
    canvasWidth.value = customWidth.value;
    canvasHeight.value = customHeight.value;
  } else {
    canvasWidth.value = sizesList.value[index].width;
    canvasHeight.value = sizesList.value[index].height;
  }
};

const setPadding = (index: number): void => {
  paddingIndex.value = index;
};

const imageSizeHandler = (): void => {
  if (imageForActions.value !== '') {
    const img = new Image();
    img.onload = () => {
      imageWidth.value = img.width;
      imageHeight.value = img.height;
      customWidth.value = img.width;
      customHeight.value = img.height;
    };
    img.src = imageForActions.value;
    key.value += 1;
  }
};

const editHandler = (image: string): void => {
  imageForActions.value = image;
  isEdit.value = false;
};

onMounted(() => {
  imageSizeHandler();
  setTimeout(() => {
    setSize(0);
  }, 100);
});

watch(imageForActions, () => {
  imageSizeHandler();
  setTimeout(() => {
    setSize(0);
  }, 100);
});

watch(customHeight, (newVal) => {
  customHeight.value = newVal > 512 ? 512 : newVal;
  canvasHeight.value = newVal;
});

watch(customWidth, (newVal) => {
  customWidth.value = newVal > 512 ? 512 : newVal;
  canvasWidth.value = newVal;
});

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_unref(imageForActions) === '' && _unref(imageResult) === '')
    ? (_openBlock(), _createBlock(AddImage, {
        key: 0,
        "is-remove-bg": ""
      }))
    : (_unref(imageForActions) !== '' && _unref(imageResult) === '')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([{ 'service__container--mobile': _unref(isMobile) }, "service__container shadow"])
        }, [
          _createElementVNode("div", _hoisted_1, [
            (isEdit.value)
              ? (_openBlock(), _createBlock(ImageFinetune, {
                  key: 0,
                  class: "shadow-edit__finetune",
                  src: _unref(imageForActions),
                  onReset: _cache[0] || (_cache[0] = ($event: any) => (isEdit.value = false)),
                  onSave: editHandler,
                  actions: ['reset', 'save']
                }, null, 8, ["src"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('shadow.settings-shadow-type')), 1),
                      _createVNode(_component_v_spacer),
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(ShadowType, {
                          modelValue: shadowType.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((shadowType).value = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('shadow.background-color')), 1),
                      _createVNode(_component_v_spacer),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(ColorsList, {
                          modelValue: shadowColor.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((shadowColor).value = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('shadow.settings-padding')), 1),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(paddingList, (item, index) => {
                            return _createVNode(AiClearButton, {
                              key: index,
                              class: _normalizeClass(["shadow-edit__settings__padding__item", { 'shadow-edit__settings__padding__item--active': paddingIndex.value === index }]),
                              onClick: ($event: any) => (setPadding(index))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_13,
                                _createVNode(_component_v_spacer),
                                _createElementVNode("div", _hoisted_14, _toDisplayString(item) + "%", 1)
                              ]),
                              _: 2
                            }, 1032, ["class", "onClick"])
                          }), 64)),
                          _createVNode(AiClearButton, {
                            class: _normalizeClass(["shadow-edit__settings__padding__item", { 'shadow-edit__settings__padding__item--active': paddingIndex.value === -1 }]),
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (setPadding(-1)))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_15,
                              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('editor.settings.custom')), 1),
                              _createVNode(_component_v_spacer),
                              _createElementVNode("div", _hoisted_17, [
                                _createVNode(_component_v_text_field, {
                                  modelValue: padding.value,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((padding).value = $event)),
                                  modelModifiers: { number: true, lazy: true },
                                  class: "shadow-edit__input",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"])
                              ])
                            ]),
                            _: 1
                          }, 8, ["class"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('common.canvas-size')), 1),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sizesList.value, (size, index) => {
                            return (_openBlock(), _createBlock(AiClearButton, {
                              key: index,
                              class: _normalizeClass(["shadow-edit__settings__sizes__item", { 'shadow-edit__settings__sizes__item--active': sizeIndex.value === index }]),
                              onClick: ($event: any) => (size.width > 512 || size.height > 512 ? null : setSize(index))
                            }, {
                              default: _withCtx(() => [
                                (size.width > 512 || size.height > 512)
                                  ? (_openBlock(), _createBlock(AiLocked, { key: 0 }))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_22, [
                                  (size.width > size.height)
                                    ? (_openBlock(), _createBlock(_component_inline_svg, {
                                        key: 0,
                                        class: "fill",
                                        src: require('@/assets/icons/sizes/horisontal.svg')
                                      }, null, 8, ["src"]))
                                    : (size.width < size.height)
                                      ? (_openBlock(), _createBlock(_component_inline_svg, {
                                          key: 1,
                                          class: "fill",
                                          src: require('@/assets/icons/sizes/vertical.svg')
                                        }, null, 8, ["src"]))
                                      : (_openBlock(), _createBlock(_component_inline_svg, {
                                          key: 2,
                                          class: "fill",
                                          src: require('@/assets/icons/sizes/square.svg')
                                        }, null, 8, ["src"]))
                                ]),
                                _createElementVNode("div", _hoisted_23, _toDisplayString(size.name), 1),
                                _createVNode(_component_v_spacer),
                                _createElementVNode("div", _hoisted_24, [
                                  _createTextVNode(_toDisplayString(size.width) + " ", 1),
                                  _hoisted_25,
                                  _createTextVNode(" " + _toDisplayString(size.height), 1)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["class", "onClick"]))
                          }), 128)),
                          _createVNode(AiClearButton, {
                            class: _normalizeClass(["shadow-edit__settings__sizes__item", { 'shadow-edit__settings__sizes__item--active': sizeIndex.value === -1 }]),
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (setSize(-1)))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_26, [
                                _createVNode(_component_inline_svg, {
                                  class: "stroke",
                                  src: require('@/assets/icons/sizes/custom.svg')
                                }, null, 8, ["src"])
                              ]),
                              _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('editor.settings.custom')), 1),
                              _createVNode(_component_v_spacer),
                              _createElementVNode("div", _hoisted_28, [
                                _createVNode(_component_v_text_field, {
                                  modelValue: customWidth.value,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((customWidth).value = $event)),
                                  modelModifiers: { number: true, lazy: true },
                                  class: "shadow-edit__input",
                                  "hide-details": "",
                                  height: "18"
                                }, null, 8, ["modelValue"]),
                                _hoisted_29,
                                _createVNode(_component_v_text_field, {
                                  modelValue: customHeight.value,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((customHeight).value = $event)),
                                  modelModifiers: { number: true, lazy: true },
                                  class: "shadow-edit__input",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"])
                              ])
                            ]),
                            _: 1
                          }, 8, ["class"])
                        ])
                      ])
                    ]),
                    (_unref(isMobile))
                      ? (_openBlock(), _createBlock(AiButton, {
                          key: 0,
                          disabled: generationLoading.value,
                          theme: "gradient-primary",
                          onClick: shadowFileHandler,
                          class: "shadow-edit__settings__button"
                        }, {
                          default: _withCtx(() => [
                            (!generationLoading.value)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('shadow.create-shadow')), 1)
                                ], 64))
                              : (_openBlock(), _createBlock(TimeCounter, { key: 1 }))
                          ]),
                          _: 1
                        }, 8, ["disabled"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(AiCard, {
                      radius: 16,
                      class: "shadow-edit__workarea__card"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "shadow-edit__workarea__container",
                          ref_key: "imgContainerRef",
                          ref: imgContainerRef
                        }, [
                          _createElementVNode("div", {
                            class: "shadow-edit__workarea__container__inner",
                            style: _normalizeStyle({
                padding: `${computedPadding.value * ratio.value}px`,
                width: `${canvasWidth.value * ratio.value}px`,
                height: `${canvasHeight.value * ratio.value}px`,
                'min-height': `${canvasHeight.value * ratio.value}px`,
              })
                          }, [
                            _createElementVNode("img", {
                              src: _unref(imageForActions),
                              alt: ""
                            }, null, 8, _hoisted_31),
                            (generationLoading.value)
                              ? (_openBlock(), _createBlock(AiDropLoader, { key: 0 }))
                              : _createCommentVNode("", true)
                          ], 4)
                        ], 512),
                        _createElementVNode("div", _hoisted_32, [
                          _createVNode(_component_v_spacer),
                          _createElementVNode("div", _hoisted_33, [
                            _createVNode(AiButton, {
                              theme: "dark",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (isEdit.value = true))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('common.correction')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(AiButton, {
                              theme: "dark",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => {
                  imageForActions.value = '';
                  imageResult.value = '';
                })
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('services.reset')), 1)
                              ]),
                              _: 1
                            }),
                            (!_unref(isMobile))
                              ? (_openBlock(), _createBlock(AiButton, {
                                  key: 0,
                                  disabled: generationLoading.value,
                                  theme: "gradient-primary",
                                  class: "shadow-edit__workarea__button",
                                  onClick: shadowFileHandler
                                }, {
                                  default: _withCtx(() => [
                                    (!generationLoading.value)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(_toDisplayString(_ctx.$t('shadow.create-shadow')), 1)
                                        ], 64))
                                      : (_openBlock(), _createBlock(TimeCounter, { key: 1 }))
                                  ]),
                                  _: 1
                                }, 8, ["disabled"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ], 64))
          ])
        ], 2))
      : (_unref(imageForActions) !== '' && _unref(imageResult) !== '')
        ? (_openBlock(), _createBlock(ResultImage, { key: 2 }))
        : _createCommentVNode("", true)
}
}

})